// src/contexts/EmotionContext.tsx - Emotion context with consciousness integration
import React, { createContext, useContext } from 'react';

export interface EmotionData {
  primary: string;
  intensity: number;
  secondary?: string;
  secondaryIntensity?: number;
  valence: 'positive' | 'negative' | 'neutral';
  narrativeInfluence?: string; // How emotion colors the narrative
  temporalTrend?: 'improving' | 'declining' | 'stable';
  consciousnessImpact?: number; // How much it affects consciousness state
}

export interface EmotionContextType {
  emotion: EmotionData;
  setEmotion: (emotion: EmotionData) => void;
}

export const EmotionContext = createContext<EmotionContextType>({
  emotion: {
    primary: 'curious',
    intensity: 0.5,
    valence: 'neutral',
    narrativeInfluence: 'open and exploratory',
    consciousnessImpact: 0.5
  },
  setEmotion: () => {}
});

export const useEmotion = () => useContext(EmotionContext);